<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Lotes
            <router-link :to="{ name: 'NuevoLote' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Lote
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <!-- <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoading"
            >
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div> -->
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="filteredItems"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #over-table>
                <CInput v-model="filter" placeholder="Búsqueda por lotes..." />
              </template>
              <template #nombre="{item, index}">
                <td class="py-2 cursor-p" @click="toggleLote(index)">
                  <span>
                    <CIcon name="cil-chevron-circle-down-alt" />
                  </span>
                  {{ item.payload.nombre }}
                </td>
              </template>
              <!-- <template #cultivo="{item, index}">
                <td class="py-2 cursor-p" @click="toggleLote(index)">
                  {{ getCultivo(item.payload.cultivo_id) }}
                </td>
              </template> -->
              <template #ubicaciones="{item, index}">
                <td class="py-2 cursor-p" @click="toggleLote(index)">
                  {{ getUbicaciones(item.payload.ubicaciones) }}
                </td>
              </template>
              <template #prod_objetivo="{item, index}">
                <td class="py-2 cursor-p" @click="toggleLote(index)">
                  {{ item.payload.produccion_objetivo }}
                </td>
              </template>
              <template #ingresos="{item, index}">
                <td class="py-2 cursor-p" @click="toggleLote(index)">
                  {{ item.payload.ingresos_objetivo }}
                </td>
              </template>
              <template #edit="{item}">
                <td class="py-2">
                  <router-link
                    :to="{ name: 'EditarLote', params: { id: item.id } }"
                  >
                    <CButton color="success" square size="sm">Editar</CButton>
                  </router-link>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="toggleCancel(index, item)"
                    >Borrar</CButton
                  >
                </td>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => changePage(e)"
                />
              </template>
              <template #details="{item, index}">
                <CCollapse :show="details.includes(index)">
                  <CCardBody class="py-0 pl-2">
                    <CDataTable
                      addTableClasses="mb-0"
                      :items="item.payload.etapas"
                      :fields="fieldsSub"
                      :header="false"
                    >
                      <template #fecha_inicial="{item}">
                        <td class="py-2">{{ getDate(item.fecha_inicial) }}</td>
                      </template>
                      <template #fecha_final="{item}">
                        <td class="py-2">{{ getDate(item.fecha_final) }}</td>
                      </template>
                      <template #edit="{item}">
                        <td class="py-2">
                          <router-link
                            :to="{
                              name: 'EditarLote',
                              params: { id: item.id }
                            }"
                          >
                            <CButton color="success" square size="sm"
                              >Editar</CButton
                            >
                          </router-link>
                        </td>
                      </template>
                      <template #cancel="{ index}">
                        <td class="py-2">
                          <CButton
                            color="danger"
                            square
                            size="sm"
                            @click="toggleCancel(index)"
                            >Borrar</CButton
                          >
                        </td>
                      </template>
                    </CDataTable>
                  </CCardBody>
                </CCollapse>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Borrar Lote"
      color="danger"
    >
      <h5 class="text-center">¿Deseas borrar el Lote {{ itemModal.name }}?</h5>
      <template #header>
        <h5 class="modal-title">Borrar Lote</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton
          @click="deleteLote(itemModal.index, itemModal.id)"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<script>
import moment from 'moment'
const fields = [
  { key: "nombre", label: "Lote", _style: "width:20%" },
  // { key: "cultivo", label: "Cultivo", _style: "width:15%" },
  { key: "ubicaciones", label: "Ubicaciones", _style: "width:25%" },
  { key: "prod_objetivo", label: "Producción Objetivo", _style: "width:20%" },
  { key: "ingresos", label: "Ingresos Objetivos", _style: "width:20%" },

  {
    key: "edit",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];
const fieldsSub = [
  { key: "nombre", label: "Etapa", _style: "width:25%" },
  { key: "presupuesto", label: "Presupuesto", _style: "width:25%" },
  { key: "fecha_inicial", label: "Fecha Inicio", _style: "width:25%" },
  { key: "fecha_final", label: "Fecha Fin", _style: "width:25%" }
];

export default {
  name: "PlanningPage",

  data() {
    return {
      items: [],
      ubicaciones: [],
      // cultivos: [],
      fields,
      fieldsSub,
      filter: "",
      cancelModal: false,
      details: [],
      itemModal: { id: "", name: "", index: "" },
      isLoading: false,
      page: 1,
      pages: 1,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" }
    };
  },

  created() {
    this.isLoading = true;
    const lote = [
      this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      }),
      // this.$store.dispatch("customHTTP", { schema: "cultivos" }),
      this.$store.dispatch("customHTTP", {
        schema: "lotes",
        limit: 50,
        page: 1,
        ["with-storage"]: ["*"]
      })
    ];
    Promise.all(lote)
      .then(([ubicaciones, lotes]) => {
      // .then(([ubicaciones, cultivos, lotes]) => {
        this.ubicaciones = ubicaciones.data;
        // this.cultivos = cultivos.data;
        this.items = lotes.data;
        this.items = lotes.data;
        this.pages = lotes.paginate.last_page;
        this.page = lotes.paginate.current_page;
      })
      .finally(() => (this.isLoading = false));
  },

  computed: {
    filteredItems() {
      return this.items.filter(
        i =>
          i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase()) ||
          this.getUbicaciones(i.payload.ubicaciones)
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          this.getCultivo(i.payload.cultivo_id)
            .toLowerCase()
            .includes(this.filter.toLowerCase())
      );
    }
  },

  methods: {
    changePage(event) {
      this.isLoading = true;
      const catalogo = [
        this.$store.dispatch("customHTTP", {
          schema: "lotes",
          limit: 50,
          page: event,
          ["with-storage"]: ["*"]
        })
      ];
      Promise.all(catalogo)
        .then(([registros]) => {
          this.items = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    getCultivo(cultivo_id) {
      const cultivoActual = this.cultivos.filter(
        cultivo => cultivo.id == cultivo_id
      );
      if (cultivoActual.length > 0) {
        return cultivoActual[0].payload.nombre;
      }
      return "";
    },
    getDate(date) {

      return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: index
      };
      this.itemModal = itemIndex;
    },
    toggleLote(index) {
      const position = this.details.indexOf(index);
      position !== -1
        ? this.details.splice(position, 1)
        : this.details.push(index);
    },
    getUbicaciones(ubicaciones) {
      let nombreUbicaciones = "";
      let ubicacionActual;
      ubicaciones.forEach(element => {
        ubicacionActual = this.ubicaciones.find(
          ubicacion => ubicacion.id == element
        );
        // console.log(ubicacionActual);

        if (ubicacionActual) {
          nombreUbicaciones = `${nombreUbicaciones}${ubicacionActual.payload.nombre}, `;
        }
      });
      let nombreUbicacionesLast = nombreUbicaciones.slice(0, -2);
      return nombreUbicacionesLast;
    },
    deleteLote(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "lotes",
          id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.cursor-p {
  cursor: pointer;
}

@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 12px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
